/* eslint-disable react-hooks/exhaustive-deps */
import Scalar from "src/libs/scalars/scalars/Scalar"
import { ICompositeWidgetProps } from "../LandingCompositeWidget"
import { Button, ButtonGroup, ButtonVariant, Collapse, Icon, Intent, Tag } from "@blueprintjs/core"
import { DotNavigation, ILanding, ILandingSection } from "../../data/interfaces"
import Shortcode from "src/libs/useful/shortcode"
import { SCALAR_TYPES, VerticalType } from "src/libs/scalars/interface/IScalarForm"
import { __ } from "src/libs/utilities"
import FieldInput from "src/libs/scalars"
import { DIALOG_SIZE, ID } from "src/libs/interfaces/layouts"
import { useEffect, useState } from "react"
import { ScalableDialog } from "src/libs/useful"
import { ILandingStore, useLandingStore } from "../../data/store"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import SingleDotBtn from "./dot-navi/SingleDotBtn"
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd"

/* Protopia Ecosystem component */ 
const DotNavigationScalar = (props: ICompositeWidgetProps): JSX.Element => {
    return <>
        <Scalar  
            value={ props.value }
            editable={props.editable }
            notClear
            rowClassName="width-auto"
            vertical={ VerticalType.VERTICAL }
            enabledForm={ <DotNavigationScalarEnabled {...props} /> }  
            desabledForm={ <DotNavigationScalarDisable {...props} /> }   
            subMenus={props.subMenus}
            onSubMenu={props.onSubmenu}
        />
    </>
}

const DotNavigationScalarEnabled = (props: ICompositeWidgetProps): JSX.Element => {
    const value                 = props.value || props.default || []
    const [isOpen, setIsOpen]   = useState<boolean>(true)
    const getDot = (section: ILandingSection ) => {
        const dot: DotNavigation = value.find( (v: DotNavigation) => v.anchor === section.id)
        if(!dot) {
            return {
                anchor: section.id,
                title: section.title.text || "Section " + section.id,
                isHidden: section.isHidden
            }
        }
        return dot
    }
    const sections = useSyncState<DotNavigation[]>( useLandingStore.getState().currentLanding.sections.map( (s:ILandingSection) => getDot(s)) )    
    useEffect(() => {
        const unsubscribe = useLandingStore.subscribe(
            ( state: ILandingStore ) => state.currentLanding,
            ( currentLanding:ILanding ) => {                
                if( sections.get().length !== currentLanding.sections.length ){                
                    sections.set( currentLanding.sections.map( s => getDot(s)) )
                }
            }
        )
        return () => unsubscribe()
    }, [])

    const onOpen = () => {
        setIsOpen( !isOpen )
    } 
    const onChange = (id: ID, value: DotNavigation) => {
        sections.set(
            sections.get().map(section => {
                if(section.anchor === id) {
                    return value
                }
                return section
            })
        )
        if(props.onChange) {
            props.onChange( sections.get(), props.field, "" )
        }
        onOpen()
    }
    const onUpdate = () => {
        sections.set( sections.get() )
        if(props.onChange) {
            props.onChange( sections.get(), props.field, "" )
        }
    }

    /*-------------------------*/
    
    // a little function to help us with reordering the result
    const reorder = (list: DotNavigation[], startIndex: number, endIndex: number) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed); 
        return result;
    }; 

    const getItemStyle = (isDragging: boolean, draggableStyle: any) => ({ 
        userSelect: "none",
        display: "flex",
        alignItems: "center",
        padding: 0,
        margin: `0 0 3px 0`, 
        width: "100%",
        // change background colour if dragging
        background: isDragging ? "#a4bcf0" : "transparent", 
        color: isDragging ? "#d1ddf5" : undefined, 
        // styles we need to apply on draggables
        ...draggableStyle
    });

    const getListStyle = (isDraggingOver: boolean) => ({
        background: isDraggingOver ? "#8885b4cc" : "transparent",
        color: isDraggingOver ? "#5e7092" : undefined, 
        padding: 0, 
    })
    const onDragEnd = (result: any) => {
        // dropped outside the list
        if (!result.destination) {
            return;
        } 
        const _items: DotNavigation[] = reorder(
            value,
            result.source.index,
            result.destination.index
        )
        if(props.onChange) {
            props.onChange( _items, props.field, "" )
        }
    }

    /*-------------------------*/

    return <div className="w-100 mb-3">
        <Button fill variant={ButtonVariant.MINIMAL} className="btn-stretch mt-3 mb-2" onClick={onOpen} alignText="left">
            <div className="title px-3">
                { __( "Dots" ) }
            </div>
        </Button>
        <Collapse isOpen={isOpen} className="w-100">
            <div className="d-flex flex-wrap w-100 px-3">
                <DragDropContext onDragEnd={ onDragEnd }>
                    <Droppable droppableId="droppable">
                        {(provided, snapshot) => (
                            <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                                style={getListStyle(snapshot.isDraggingOver)}
                            >
                                { 
                                    value.map((val: DotNavigation, i: number) => {
                                        return <div key={val.anchor} className="d-flex"> 
                                            <Draggable draggableId={ val.anchor.toString() } index={ i }>
                                                {(provided, snapshot) => {
                                                    return  <div
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        style={getItemStyle(
                                                            snapshot.isDragging,
                                                            provided.draggableProps.style
                                                        )}
                                                    > 
                                                        <SingleDotBtn 
                                                            value={ val } 
                                                            i={ i }
                                                            key={ val.anchor } 
                                                            values={ props.value }  
                                                            onChange={ onChange }
                                                        />
                                                    </div>
                                                }}
                                            </Draggable>
                                        </div>
                                })}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
            </div>
        </Collapse>
        <Button fill variant={ButtonVariant.MINIMAL} className="btn-stretch mt-3 mb-2" onClick={onUpdate} alignText="left">
            <div className="smaller letter-spacing-2 text-uppercase px-3">
                { __( "Update dots to actual" ) }
            </div>
        </Button>
    </div>
}
const DotNavigationScalarDisable = (props: ICompositeWidgetProps): JSX.Element => {
    const tags = ( props.value || [] ).map( (v: DotNavigation) => {
        return <Tag key={v.anchor}>
            <Shortcode content={v.title} className="small landing-tooltip" />
        </Tag>
    })
    return <div className="d-flex flex-wrap">{ tags }</div>
}

export default DotNavigationScalar